import React, { useContext, useEffect, useState } from "react";
import {
  IdentityContext,
  UserManagerContext,
  ApiAuthorizationRoutes,
} from "@react-beets/identity";
import { Route, Switch, useLocation } from "react-router-dom";
import { ROUTES } from "../constants";
import * as Pages from "../pages";
import AddPropertyLease from "../pages/AppAddProperty/lease";
import AddPropertyUnit from "../pages/AppAddProperty/unit";
import AddPropertyUnitLease from "../pages/AppAddProperty/unitLease";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import NotificationAlert from "../components/Layout/NotificationAlert";

function App() {
  const { userManager } = useContext(UserManagerContext);
  const { isAuthenticated, login, identity } = useContext(IdentityContext);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  var _setItem = Storage.prototype.setItem;
  Storage.prototype.setItem = function(key, value) { 
         // fallback to default action
         _setItem.apply(this, arguments);    
  } 
  
  var _removeItem = Storage.prototype.removeItem;
  Storage.prototype.removeItem = function(key, value) {
         if (key === 'reactbeetsuser:https://auth.rentbeets.com:reactbeets'){
          debugger;
         }
         // fallback to default action
         _removeItem.apply(this, arguments);
  } 

  useEffect(() => {
    const load = async () => {
      try {
        // Skip auto-login if we're on an authentication callback route
        // Let the callback handler process the login instead
        if (location.pathname.startsWith('/authentication/')) {
          console.log("On authentication callback route, skipping auto-login");
          setLoading(false);
          return;
        }

        // Check if user already exists in storage
        const existingUser = await userManager.getUser();
        if (existingUser && !existingUser.expired) {
          console.log("User already in storage, using existing session");
          login(existingUser);
          setLoading(false);
          return;
        }

        console.log("Auto login started");
        const signInArguments = { useReplaceToNavigate: true };
        await userManager?.signinSilent(signInArguments);
        const user = await userManager.getUser();
        login(user);
      } catch(e){
        console.error("Auto login but error was returned", e);
      } finally {
        setLoading(false);
      }
    }
    if (userManager) {
      load()
    }
  }, [userManager, location.pathname]);

  return (
    <>
      <ScrollToTop />
      <NotificationAlert></NotificationAlert>      
      <Switch>
        <Route exact path={ROUTES.WEBSITE_HOME} component={Pages.WebsiteHome} />
        <Route
          exact
          path={ROUTES.WEBSITE_ABOUT}
          component={Pages.WebsiteAbout}
        />
        <PrivateRoute
          exact
          path={ROUTES.APP_HOME}
          component={Pages.AppHome}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={ROUTES.PRIVATE_PROPERTIES}
          component={Pages.AppPrivateProperties}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={ROUTES.ADD_PROPERTY}
          component={Pages.AppAddProperty}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.ADD_PROPERTY}/:id`}
          component={Pages.AppAddProperty}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.ADD_PROPERTY}/:id/lease`}
          component={AddPropertyLease}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.ADD_PROPERTY}/:id/unit`}
          component={AddPropertyUnit}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.ADD_PROPERTY}/:id/unit/:unitid`}
          component={AddPropertyUnit}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.ADD_PROPERTY}/:id/unit/:unitid/lease`}
          component={AddPropertyUnitLease}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.PROPERTY}/:id`}
          component={Pages.AppProperty}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.PROPERTY}/:id/unit`}
          component={Pages.AppUnit}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.PROPERTY}/:id/unit/:unitid`}
          component={Pages.AppUnit}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.ADD_LISTING}/:id/unit/:unitid`}
          component={Pages.AppAddListing}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={ROUTES.PRIVATE_LISTINGS}
          component={Pages.AppPrivateListings}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={`${ROUTES.PRIVATE_LISTINGS}/:id`}
          component={Pages.AppPrivateListing}
          loading={loading}
        />
        <Route
          exact
          path={`${ROUTES.LISTINGS}/:id`}
          component={Pages.WebsitePublicListing}
        />
        {/* Login page now handled by server at /identity/login */}
        <Route
          exact
          path={ROUTES.IDENTITY_REGISTER}
          component={Pages.IdentityRegister}
        />
        <Route
          exact
          path={ROUTES.IDENTITY_FORGOT_PASSWORD}
          component={Pages.IdentityForgotPassword}
        />
        <Route
          exact
          path={ROUTES.IDENTITY_RESET_PASSWORD}
          component={Pages.IdentityResetPassword}
        />
        <Route
          exact
          path={ROUTES.IDENTITY_CONFIRM_EMAIL}
          component={Pages.IdentityConfirmEmail}
        />
        <PrivateRoute
          exact
          path={ROUTES.MANAGE_PROFILE}
          component={Pages.ManageProfile}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={ROUTES.MANAGE_CHANGE_PASSWORD}
          component={Pages.ManageChangePassword}
          loading={loading}
        />
        <PrivateRoute
          exact
          path={ROUTES.MANAGE_PERSONAL_DATA}
          component={Pages.ManagePersonalData}
          loading={loading}
        />
        <ApiAuthorizationRoutes />
      </Switch>
    </>
  );
}

export default App;
